<template>
    <BrowsePageContainer />
</template>

<script>
import { SET_404_ERROR } from '~coreModules/core/js/store';
import browseModule, { BROWSE_MODULE_NAME, FETCH_BROWSE_INFORMATION } from '~routes/browse/js/browse-store';

import { getAllBrands } from '~routes/brands/js/brands-api';

import BrowsePageContainer from '~routes/browse/components/BrowsePageContainer.vue';

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Brand',
    components: {
        BrowsePageContainer,
    },
    vuex: {
        moduleName: BROWSE_MODULE_NAME,
        module: browseModule,
    },
    fetchData({ app, route, store }) {
        return getAllBrands(app.$r15Svc)
            .then((response) => {
                const foundBrand = response.brands.find(brand => brand.slug === route.params.slug);
                if (foundBrand) {
                    return store.dispatch(`${BROWSE_MODULE_NAME}/${FETCH_BROWSE_INFORMATION}`,
                        {
                            slug: 'vendor-brands',
                            route: {
                                ...route,
                                query: { ...route.query, vendorBrands: foundBrand.name },
                            },
                            brandSlug: route.params.slug,
                        });
                }

                store.commit(SET_404_ERROR, { message: `Unable to find brand: ${route.params.slug}` });
                return Promise.resolve();
            })
            .catch((error) => {
                app.$logger.debugError('Failed to fetch all brands: ', error);
                store.commit(SET_404_ERROR, { message: error?.data?.message });
            });
    },
};
</script>

<style lang="scss">

</style>
